<template lang="pug">
.crud
  .container-fluid
    .card
      .title
        CardTitle(:text="$t('shipments.add')" icon="archive-outline")
      .step1.direct-flex(style="margin-top: 15px;")
        NumberCircle(text="1")
        h1.space-grotesk {{ $t('purchase_orders.general_data') }}
      vm-row(vm-align="center" vm-type="flex" vm-w="12")
        vm-row(v-if="!isSFS" vm-align="center" vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=4)
            b-form-group
              vm-select(:disabled="hasBranch()" :placeholder='$t("branches.branch_placeholder")' :danger="$v.newShipment.branch_id.$invalid && $v.newShipment.branch_id.$model" :danger-text="$t('validation.required', { attribute: $t('branches.branch') })" v-model="newShipment.branch_id" :label='$t("branches.branch")')
                vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in branches")
        vm-col(vm-justify="center", vm-align="center", vm-w=4)
          b-form-group.separator
            vm-select(:placeholder='$t("purchase_orders.supplier_placeholder")' :danger="$v.newShipment.supplier_id.$invalid && $v.newShipment.supplier_id.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.supplier_display') })" v-model="newShipment.supplier_id" :label='$t("purchase_orders.supplier_display")')
              vm-select-item(:key='index', :value='item.id', :text='item.business_name', v-for='item,index in suppliers')
        vm-col(vm-justify="center", vm-align="center", vm-w=4)
          b-form-group.separator
            vm-date-picker.full-width(type="date" :label="$t('shipments.shipment_date')" :placeholder="$t('strings.select_date')" :danger="$v.newShipment.shipment_date.$invalid && $v.newShipment.shipment_date.$model" :danger-text="$t('validation.required', { attribute: $t('shipments.shipment_date') })" v-model="newShipment.shipment_date" )
        vm-col(vm-justify="center", vm-align="center", vm-w=4)
          b-form-group.separator
            vm-input(:placeholder='$t("shipments.lead_time_placeholder")' :label='$t("shipments.lead_time")' :danger="$v.newShipment.lead_time.$invalid && $v.newShipment.lead_time.$model" :danger-text="$t('validation.required', { attribute: $t('shipments.lead_time') })" v-model="newShipment.lead_time")
        .step2.direct-flex
          NumberCircle(text="2")
          h1.space-grotesk {{ $t('purchase_orders.added_products') }}
        vm-col.direct-flex(vm-sm=12)
          div#spreadsheet.separator
          vm-col(vm-sm=2)
            vm-button(style="margin-left: 15px;" @click="cleanTab") {{ $t('strings.clear') }}
        vm-row(vm-sm="12")
          vm-col(vm-sm=12)
            vm-button.float-right(style="margin-top: 15px;" @click="saveShipment") {{ $t('strings.save') }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import jspreadsheet from 'jspreadsheet-ce'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Shipments')

export default {
  name: 'TabShipments',
  components: {
    CardTitle: () => import('@/components/elements/CardTitle'),
    NumberCircle: () => import('@/components/elements/NumberCircle')
  },
  data: () => ({
    newShipment: {},
    cleanData: [],
    spread: null,
    customColumn: {
      closeEditor: function (cell, save) {
        var value = cell.children[0].value
        cell.innerHTML = value
        return value
      },
      openEditor: function (cell) {
        var element = document.createElement('input')
        element.value = cell.innerHTML
        cell.classList.add('editor')
        cell.innerHTML = ''
        element.focus()
      },
      getValue: function (cell) {
        return cell.innerHTML
      },
      setValue: function (cell, value) {
        cell.innerHTML = value
      }
    }
  }),
  validations () {
    return {
      newShipment: {
        supplier_id: {
          required
        },
        shipment_date: {
          required
        },
        lead_time: {
          required
        },
        branch_id: {
          required: requiredIf(function () {
            return !this.isSFS
          })
        }
      }
    }
  },
  mixins: [ViewMixinMaster1],
  computed: {
    ...mapGetters([
      'suppliers',
      'tabSheet',
      'validOrder',
      'approvedOrder',
      'purchaseOrderDetails',
      'convertedDetails',
      'branches'
    ]),
    ...configMapGetters(['isSFS'])
  },
  async created () {
    this.cleanSpreadSheet()
    this.getSuppliers()
    if (!this.isSFS) {
      if (this.hasBranch()) this.addBranch()
      this.getBranches()
    }
  },
  methods: {
    ...mapActions([
      'getSuppliers',
      'addShipment',
      'convertToArrayOfObjects',
      'validateOrderDetail',
      'cleanSpreadSheet',
      'purchaseOrderIsAproved',
      'checkBalanceByOrderDetail',
      'updatePurchaseOrderDetailQuantities',
      'getBranches'
    ]),
    removeEmptyValues () {
      this.cleanData = this.tabSheet.filter(function (item) { return item[0] !== '' })
    },
    async saveShipment () {
      this.removeEmptyValues()
      this.convertToArrayOfObjects(this.cleanData)
      this.purchaseOrderIsAproved(this.convertedDetails).then(() => {
        if (this.approvedOrder) {
          this.validateOrderDetail(this.convertedDetails).then(() => {
            if (this.tabSheet.length && this.validOrder) {
              const data = {
                ...this.newShipment,
                details: this.purchaseOrderDetails
              }
              this.addShipment(data).then(() => {
                this.updatePurchaseOrderDetailQuantities({ details: this.purchaseOrderDetails }).then(() => {
                  this.checkBalanceByOrderDetail(this.purchaseOrderDetails).then(() => {
                    this.newShipment = {}
                    this.cleanTab()
                  })
                })
              })
            }
          })
        }
      })
    },
    onRenderSpread () {
      this.spread = jspreadsheet(document.getElementById('spreadsheet'), {
        data: this.tabSheet,
        minDimensions: [1, 1],
        allowInsertRow: true,
        allowManualInsertRow: false,
        allowInsertColumn: false,
        columns: [
          { title: 'FolioOC', width: 200 },
          { title: 'Codigo', width: 200 },
          { title: 'Cantidad', width: 200 }
        ],
        filters: false,
        allowComments: true
      })
    },
    cleanTab () {
      this.cleanSpreadSheet()
      this.spread.destroy()
      this.onRenderSpread()
    },
    hasBranch () {
      return Boolean(this.$auth.user().branch_id)
    },
    addBranch () {
      this.newShipment = { ...this.newShipment, branch_id: this.$auth.user().branch_id }
    }
  },
  async mounted () {
    this.onRenderSpread()
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
.padding {
  padding: 3px 0px;
}
</style>
